/// <amd-module name="Artifacts/Ivy/components/IvyPackageOverview" />
import { getFiles, getHrefLink, IIvyFile } from "Artifacts/Ivy/helpers/IvyFileHelper";
import * as IvyRes from "Artifacts/Ivy/Resources";
import { PackageTile } from "Artifacts/Package/components/package-details-common/PackageTile";
import { IProtocolOverviewProps } from "Artifacts/Root/protocols/types";
import { IFeed } from "Artifacts/Root/types/IFeed";
import { IPackage } from "Artifacts/Root/types/IPackage";
import { IPackageVersion } from "Artifacts/Root/types/IPackageVersion";
import * as React from "react";
import { ISimpleListCell, SimpleList } from "VSSUI/List";
import { ArrayItemProvider } from "VSSUI/Utilities/Provider";

const IvyOverview: React.FC<IProtocolOverviewProps> = ({ feed, pkg, version }) => {
  return (
    <div className="ivy-overview-content package-overview-content">
      {version.description && version.description.length > 0 && (
        <PackageTile title={IvyRes.Ivy_Description_Title}>
          <div className="package-description">{version.description}</div>
        </PackageTile>
      )}
      <PackageTile title={IvyRes.Ivy_Publications_Title}>
        <SimpleList
          itemProvider={
            new ArrayItemProvider<ISimpleListCell>(
              getFiles(version).map((file) => renderFile(feed, pkg, version, file)),
            )
          }
        />
      </PackageTile>
    </div>
  );
};

function renderFile(
  feed: IFeed,
  pkg: IPackage,
  version: IPackageVersion,
  file: IIvyFile,
): ISimpleListCell {
  let feedId = feed.id;

  if (feed.selectedViewId) {
    feedId = feed.id + "@" + feed.selectedViewId;
  }

  return {
    href: getHrefLink(feedId, pkg.name, version.normalizedVersion, file.name),
    textClassName: "package-link-text",
    hrefRel: "noopener noreferrer",
    text: file.name,
  } as ISimpleListCell;
}

export { IvyOverview };
